export default __webpack_public_path__ + "static/media/misc-drawerB.e545037a.jpg";